import { NgModule } from '@angular/core';
import { WebsiteFooterComponent } from './website-footer/website-footer.component';
import { WebsiteHeaderComponent } from './website-header/website-header.component';
import { IndexComponent } from './index/index.component';
import { StandartComponent } from './Standart/standart.component';
import { ListClientsComponent } from './ClientSection/list-clients/list-clients.component';
import { ExpedierMemberComponent } from './ClientSection/expedier-member/expedier-member.component';
import { EstimerTarifComponent } from './ClientSection/estimer-tarif/estimer-tarif.component';
import { EstimerTempsTransitComponent } from './ClientSection/estimer-temps-transit/estimer-temps-transit.component';
import { HistoriqueEnvoisComponent } from './ClientSection/historique-envois/historique-envois.component';
import { SharedModule, createTranslateLoader } from '../shared.module';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    WebsiteFooterComponent,
    WebsiteHeaderComponent,
    IndexComponent,
    StandartComponent,
    ListClientsComponent,
    ExpedierMemberComponent,
    EstimerTarifComponent,
    EstimerTempsTransitComponent,
    HistoriqueEnvoisComponent,
  ],
  imports: [
    RouterModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    SharedModule
  ]
})
export class WebsiteModule {}
